/**
 * WordPress dependencies
 */
import { SelectControl } from '@safe-wordpress/components';
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import clsx from 'clsx';

/**
 * Control to display word break options.
 *
 * @param {Object} props Component props.
 *
 * @return {Element} Word break control.
 */
type WordBreakControlProps = {
	readonly __next40pxDefaultSize?: boolean;
	readonly value: {
		readonly wordBreak?: string;
	};
	readonly onChange: ( value: { wordBreak?: string } ) => void;
	readonly size?: string;
	readonly disabled?: boolean;
};
export function WordBreakControl(
	props: WordBreakControlProps
): JSX.Element | false {
	const {
		/** Start opting into the larger default height that will become the default size in a future version. */
		__next40pxDefaultSize = false,
		onChange,
		value: { wordBreak },
		disabled,
	} = props;

	const selectOptions = [
		{
			value: 'normal',
			label: 'Normal',
		},
		{
			value: 'keep-all',
			label: 'Keep all',
		},
		{
			value: 'break-all',
			label: 'Break all',
		},
		{
			value: 'break-word',
			label: 'Break word',
		},
	];

	// Find current selection by comparing word break against options,
	// and fall back to the Default option if there is no matching option.
	const currentSelection =
		selectOptions.find( ( option ) => option.value === wordBreak ) ||
		selectOptions[ 0 ];

	return (
		<SelectControl
			disabled={ disabled }
			className={ clsx( 'components-word-break-control', {
				'nab-components--disabled': disabled,
			} ) }
			__next40pxDefaultSize={ __next40pxDefaultSize }
			__nextHasNoMarginBottom
			label={ _x( 'Word break', 'text', 'nelio-ab-testing' ) }
			options={ selectOptions }
			value={ currentSelection?.value }
			onChange={ ( selectedItem ) =>
				onChange( { wordBreak: selectedItem } )
			}
		/>
	);
}
